export const STREET_NUMBER_PATTERNS = {
	descriptive: /^[0-9]+$/,
	orientation: /^[0-9]+[a-z]?$/,
	evidence: /^(?:[Ee]|0)?[0-9]+$/,
} as const;
